module.exports = __webpack_public_path__ + "static/img/9.5a34ace.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/9.png
// module id = aDkT
// module chunks = 0